import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core'
import { AuthService } from 'src/app/components/isbeauth/auth.service'
import { ImportantNoticeSetting, NavService } from 'src/app/components/nav/nav.service'

@Component({
  selector: 'app-important-notice-popup',
  templateUrl: './important-notice-popup.component.html',
  styleUrls: ['./important-notice-popup.component.scss']
})
export class ImportantNoticePopupComponent implements OnInit {
  @Input() showDontShowAgainKey: string = ''
  @Input() viewCd: string = ''
  @Output() close = new EventEmitter<void>()
  @ViewChild('actionTransactionBtn', { static: false }) actionTransactionBtn: ElementRef
  isVisible = false
  notice: ImportantNoticeSetting = null
  actionTransactionCommandCd: string = ''
  dontShowAgainInput = false
  constructor(private authService: AuthService, private navService: NavService) {}

  ngOnInit(): void {}

  show(): void {
    const notificationData = this.navService.getImportantNoticeAction
    this.notice = notificationData
    if (!this.notice) {
      // 通知データがない場合は、データを取得してから再実行
      this.navService.updateImportantNotice().then(() => {
        this.show() // 再帰的に呼び出し
      })
      return
    }

    // 終了日時をチェック
    if (this.notice.endDatetime) {
      const now = new Date()
      const endDate = new Date(this.notice.endDatetime)
      if (now > endDate) {
        // 期限切れの場合は終了
        return
      }
    }

    // 「今後表示しない」設定をチェック
    if (this.showDontShowAgainKey && this.shouldSkipDisplay()) {
      return
    }

    // ポップアップを表示
    this.isVisible = true

    // アクショントランザクションを記録
    this.triggerActionTransaction()
  }

  iconSrc(): string {
    let src = 'assets/images/petabo-infomation/icon-important70o.gif'
    switch (this.notice?.notificationDivision) {
      case '1': // 重要なお知らせ
        src = 'assets/images/petabo-infomation/icon-important70o.gif'
        break
      case '2': // 障害・メンテナンス
        src = 'assets/images/petabo-infomation/icon-failure70.gif'
        break
    }
    return src
  }

  private shouldSkipDisplay(): boolean {
    const accountId = this.authService.AccountInfo?.accountId
    if (!accountId || !this.showDontShowAgainKey) {
      return false
    }

    // ローカルストレージをチェック
    const dontShowData = localStorage.getItem(this.showDontShowAgainKey)

    // アカウントIDごとのフラグをチェック
    if (dontShowData) {
      try {
        const accountFlags = JSON.parse(dontShowData)
        return accountFlags[accountId] === true
      } catch (error) {
        console.warn('Failed to parse localStorage data:', error)
      }
    }
    return false
  }

  // 閉じるボタンがクリックされたときの処理
  onClose(): void {
    const accountId = this.authService.AccountInfo?.accountId
    if (accountId && this.showDontShowAgainKey && this.dontShowAgainInput) {
      this.saveDontShowAgainFlag()
    }
    this.isVisible = false
    this.close.emit()
  }

  private saveDontShowAgainFlag(): void {
    const accountId = this.authService.AccountInfo?.accountId
    if (!accountId || !this.showDontShowAgainKey) {
      return
    }

    // 既存のデータを取得
    let accountFlags = {}
    const existingData = localStorage.getItem(this.showDontShowAgainKey)
    if (existingData) {
      try {
        accountFlags = JSON.parse(existingData)
      } catch (error) {
        console.warn('Failed to parse existing localStorage data:', error)
        accountFlags = {}
      }
    }

    // 現在のアカウントIDのフラグを設定
    accountFlags[accountId] = true
    localStorage.setItem(this.showDontShowAgainKey, JSON.stringify(accountFlags))
  }

  // 表示時にActionTransactionのクリックイベントを発生させる
  private triggerActionTransaction(): void {
    if (!this.notice.actionTransactionKey || !this.viewCd) {
      return
    }
    let key = this.notice.actionTransactionKey
    // keyの中の{viewCd}となっている部分を置換
    key = key.replace('{viewCd}', this.viewCd)
    this.actionTransactionCommandCd = key
    // DOM要素が準備できるまで少し待ってからクリック
    setTimeout(() => {
      if (this.actionTransactionBtn?.nativeElement) {
        this.actionTransactionBtn.nativeElement.click()
      }
    }, 100)
  }
}
